
// Cart Savings Banner Controller
const nrProductCache = new Map();

function nrFetchProduct(handle) {
  if (!nrProductCache.has(handle)) {
    nrProductCache.set(handle, fetch(`/products/${handle}.js`).then(r => r.json()).catch(() => null));
  }
  return nrProductCache.get(handle);
}

async function updateCartBanner() {
  const banner = document.querySelector('.nr-cart-banner');
  if (!banner) return;

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    if (cart.item_count === 0) {
      banner.style.opacity = '0';
      setTimeout(() => banner.style.display = 'none', 300);
      return;
    }

    // Check for discount codes
    let hasSavings = cart.total_discount > 0;

    // If no discount code, check for compare_at_price savings (parallel, gecached)
    if (!hasSavings) {
      const products = await Promise.all(cart.items.map(item => nrFetchProduct(item.handle)));
      hasSavings = cart.items.some((item, i) => {
        const product = products[i];
        if (!product) return false;
        const variant = product.variants.find(v => v.id === item.variant_id);
        return !!(variant && variant.compare_at_price && variant.compare_at_price > variant.price);
      });
    }

    if (hasSavings) {
      banner.style.display = 'block';
      setTimeout(() => banner.style.opacity = '1', 10);
    } else {
      banner.style.opacity = '0';
      setTimeout(() => banner.style.display = 'none', 300);
    }
  } catch (e) {
    // Hide on error
    banner.style.opacity = '0';
    setTimeout(() => banner.style.display = 'none', 300);
  }
}

// Debounce: pubsub + cart:updated feuern oft direkt nacheinander — ein Lauf reicht
let nrBannerTimer = null;
function scheduleCartBannerUpdate() {
  clearTimeout(nrBannerTimer);
  nrBannerTimer = setTimeout(updateCartBanner, 100);
}

// Run on load (drawer just opened)
scheduleCartBannerUpdate();

// Listen to cart events
['cart:updated', 'cart:refresh'].forEach(event => {
  document.addEventListener(event, scheduleCartBannerUpdate);
});

// Listen to theme's pubsub
if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe) {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, scheduleCartBannerUpdate);
}
